import React from "react";
import intl from "react-intl-universal";


import type {CalendarTable} from "../../../screens/Lists/components/CalendarTable";
import {TaskReport} from "../../../../stores/taskLists/gql/serverTypes";


import {formatDayWithMonthAndTime} from "../../../../utils/date";


export interface TaskReportMissedProps {
    report: TaskReport;
    calendarTable: CalendarTable;
}

export const TaskReportMissed = (
    {
        calendarTable,
        report
    }: TaskReportMissedProps
) => {

    const task = calendarTable.taskDs?.getTaskById(report.taskId);
    const taskName = task?.name;
    const taskListUnit = calendarTable.taskListUnitDS.getTaskListUnitById(report.taskListUnitId);
    const taskListName = Object.values(taskListUnit?.taskLists ?? {}).find(list => list.id === task?.taskListId)?.name ?? intl.get('taskList.ungrouped.short').d('Ungrouped Tasks');

    return (
        <div>
            <div className="TaskReportEdit__ContentBlock">
                <div className="title-large-bold TaskReportEdit__ContentBlock__taskName">{taskName}</div>
                <div className="body-medium TaskReportEdit__ContentBlock__tasklListName">{taskListName}</div>
                <div className="TaskReportComplete__ContentBlock">
                    {intl.getHTML('TaskReportMissed.description.text').d('<strong>This task was missed.</strong> No report was submitted, so the system marked it as incomplete by the end of the day.')}
                </div>
            </div>
            <div className="TaskReportEdit__ContentBlock">
                <div className={"TaskReportComplete__ReportUserInfo body-medium"}>
                    {intl.get('TaskReportComplete.created.noUser', {
                        date: formatDayWithMonthAndTime(report.createdAt)
                    }).d('Created: on {date}')}
                </div>
            </div>
        </div>
    );
};
